export default __webpack_public_path__ + "static/media/my-profile.53380058.png";